/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Image_Export_Preview_Generate_ButtonInputs */

const en_image_export_preview_generate_button = /** @type {(inputs: Image_Export_Preview_Generate_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Generate Preview`)
};

const fr_image_export_preview_generate_button = /** @type {(inputs: Image_Export_Preview_Generate_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Generer la previsualisation`)
};

const de_image_export_preview_generate_button = /** @type {(inputs: Image_Export_Preview_Generate_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vorschau generieren`)
};

const it_image_export_preview_generate_button = /** @type {(inputs: Image_Export_Preview_Generate_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Genera anteprima`)
};

const ru_image_export_preview_generate_button = /** @type {(inputs: Image_Export_Preview_Generate_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Создать предварительный просмотр`)
};

const es_image_export_preview_generate_button = /** @type {(inputs: Image_Export_Preview_Generate_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Generar vista previa`)
};

const zh_cn2_image_export_preview_generate_button = /** @type {(inputs: Image_Export_Preview_Generate_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`生成预览`)
};

const ja_image_export_preview_generate_button = /** @type {(inputs: Image_Export_Preview_Generate_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`プレビューを生成`)
};

const hi_image_export_preview_generate_button = /** @type {(inputs: Image_Export_Preview_Generate_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`पूर्वावलोकन उत्पन्न करें`)
};

const pt_pt2_image_export_preview_generate_button = /** @type {(inputs: Image_Export_Preview_Generate_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gerar pré-visualização`)
};

/**
* | output |
* | --- |
* | "Generate Preview" |
*
* @param {Image_Export_Preview_Generate_ButtonInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const image_export_preview_generate_button = /** @type {((inputs?: Image_Export_Preview_Generate_ButtonInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Image_Export_Preview_Generate_ButtonInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_image_export_preview_generate_button(inputs)
	if (locale === "de") return de_image_export_preview_generate_button(inputs)
	if (locale === "it") return it_image_export_preview_generate_button(inputs)
	if (locale === "ru") return ru_image_export_preview_generate_button(inputs)
	if (locale === "es") return es_image_export_preview_generate_button(inputs)
	if (locale === "zh-CN") return zh_cn2_image_export_preview_generate_button(inputs)
	if (locale === "ja") return ja_image_export_preview_generate_button(inputs)
	if (locale === "hi") return hi_image_export_preview_generate_button(inputs)
	if (locale === "pt-PT") return pt_pt2_image_export_preview_generate_button(inputs)
	return en_image_export_preview_generate_button(inputs)
});